/* eslint-disable no-empty-pattern */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const dealRequest = createAsyncThunk(
  "dealReq/dealRequest",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/business/deals/joint-venture", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  },
);

export const allDealsList = createAsyncThunk(
  "dealReq/allDealsList",
  async ({ statusId, dealCategoryId } = {}, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();

      if (statusId) {
        queryParams.append("statusId", statusId);
      }

      if (dealCategoryId) {
        queryParams.append("dealCategoryId", dealCategoryId);
      }

      const response = await axios.get(
        `/api/business/allDealsList?${queryParams.toString()}`,
      );

      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  },
);

export const dealAutofill = createAsyncThunk(
  "dealReq/dealAutofill",
  async (arg, { rejectWithValue }) => {
    try {
      const orgId = typeof arg === "string" ? arg : arg?.orgId;
      const dealId = typeof arg === "object" && arg ? arg.dealId : undefined;
      const url = orgId
        ? `/api/business/JV/dealAutofill/${orgId}`
        : `/api/business/JV/dealAutofill`;
      const response = await axios.get(url, {
        params: dealId ? { dealId } : undefined,
      });
      return response?.response ?? null;
    } catch (error) {
      try {
        const orgId = typeof arg === "string" ? arg : arg?.orgId;
        const dealId = typeof arg === "object" && arg ? arg.dealId : undefined;
        const fallbackUrl = orgId
          ? `/api/admin/JV/dealAutofill/${orgId}`
          : `/api/admin/JV/dealAutofill`;
        const response = await axios.get(fallbackUrl, {
          params: dealId ? { dealId } : undefined,
        });
        return response?.response ?? null;
      } catch (fallbackError) {
        return rejectWithValue(
          fallbackError?.response?.data || fallbackError?.message || error?.response?.data || error?.message || "Failed to fetch autofill data"
        );
      }
    }
  }
);

export const dealReqSlice = createSlice({
  name: "dealReq",
  initialState: {
    loading: false,
    error: "",
    dealReqLoading: false,
    dealReqError: "",
    dealList: [],
    dealAutofillList: null,
    dealAutofillLoading: false,
    dealAutofillError: "",
  },

  reducers: {
    resetDealAutofill: (state) => {
      state.dealAutofillList = null;
      state.dealAutofillLoading = false;
      state.dealAutofillError = "";
    },
  },

  extraReducers: (builder) => {
    builder.addCase(dealRequest.pending, (state) => {
      state.dealReqLoading = true;
      state.dealReqError = "";
    });
    builder.addCase(dealRequest.fulfilled, (state, action) => {
      state.dealReqLoading = false;
      state.dealReqError = "";
    });
    builder.addCase(dealRequest.rejected, (state, action) => {
      state.dealReqLoading = false;
      state.dealReqError = action.payload;
    });

    builder.addCase(allDealsList.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(allDealsList.fulfilled, (state, action) => {
      state.loading = false;
      state.dealList = action.payload;
      state.error = "";
    });
    builder.addCase(allDealsList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(dealAutofill.pending, (state) => {
      state.dealAutofillLoading = true;
      state.dealAutofillError = "";
      state.dealAutofillList = null;
    });
    builder.addCase(dealAutofill.fulfilled, (state, action) => {
      state.dealAutofillLoading = false;
      state.dealAutofillError = "";
      state.dealAutofillList = action.payload;
    });
    builder.addCase(dealAutofill.rejected, (state, action) => {
      state.dealAutofillLoading = false;
      state.dealAutofillList = null;
      state.dealAutofillError = action.payload;
    });
  },
});

export const { resetDealAutofill } = dealReqSlice.actions;

export default dealReqSlice.reducer;

